import React from 'react';
import {useOutletContext} from "react-router";
import {Typography, useMediaQuery} from "@mui/material";
import Grid from "@mui/material/Grid";
import {RosterGrid} from '../components/grids/RosterGrid';
import {config} from '../config';
import {rosterGridTypes} from "../utils";

const managerNames = config.managerNames;

export const PreDraftContainer = () => {
    const {currentAuction} = useOutletContext();

    const isMobile = useMediaQuery('(max-width: 1420px)');

    const tableRows = [];
    if (isMobile) {
        for (let i = 0; i < 8; i++) {
            tableRows.push(
                <tr key={`tr${i}t`}>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i]}</Typography></td>
                </tr>);
            tableRows.push(
                <tr key={`tr${i}b`}>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.PROJECTED} managerName={managerNames[i]}
                                    seasonYear={currentAuction.season_year} weekNum={currentAuction.week_num}/>
                    </td>
                </tr>)
        }
    } else {
        for (let i = 0; i < 8; i += 2) {
            tableRows.push(
                <tr key={`tr${i}`}>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i]}</Typography></td>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i + 1]}</Typography></td>
                </tr>);
            tableRows.push(
                <tr key={`tr${i + 1}`}>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.PROJECTED} managerName={managerNames[i]}
                                    seasonYear={currentAuction.season_year} weekNum={currentAuction.week_num}/>
                    </td>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.PROJECTED} managerName={managerNames[i + 1]}
                                    seasonYear={currentAuction.season_year} weekNum={currentAuction.week_num}/>
                    </td>
                </tr>)
        }
    }

    const justify = isMobile ? 'flex-start' : 'center';
    return (
        <div>
            <Grid container justifyContent={justify}>
                <table>
                    <tbody>
                    {tableRows}
                    <tr>
                        <td style={{height: 100}}/>
                        <td style={{height: 100}}/>
                    </tr>
                    </tbody>
                </table>
            </Grid>
        </div>
    );
}